import React from "react";
import {connect} from 'react-redux'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomWizard from "views/Components/CustomWizard.jsx";

import Platforms from './Platforms'
import Forex from './Forex'
import Indices from './Indices'
import Commodities from './Commodities'
import Cryptos from './Cryptos'
import Shares from './Shares'
import Futures from './Futures'

//ibs
import {
  ibSave,
  ibsFetch,
  ibFetch
} from 'actions/ibs'
import {
  companiesFetch,
  companyFilter
} from 'actions/companies'
import {
  currenciesFetch,
  currencyFilter
} from 'actions/currencies'
import {
  plaformsFetch,
  plaformFilter
} from 'actions/platforms'

import {
  danger,
  success,
} from 'actions/notification'

import {
  fetchAllSymbols
} from 'actions/symbols'
import {
  symbolGroupsFetch,
  symbolGroupFilter
} from 'actions/symbolGroups'
import {
  profileSpecialCasesFetch,
} from 'actions/profileSpecialCases'
import {profileFetch, fetchedSingleProfile} from 'actions/profiles'
//styles
import styles from "assets/jss/material-dashboard-pro-react/views/form";


const steps = [
  {stepName: 'Platforms', stepId:"1", stepComponent:Platforms},
	{stepName: 'Forex', stepId:"2", stepComponent:Forex},
	{stepName: "CFD's Indices", stepId:"3", stepComponent:Indices},
	{stepName: "CFD's Commodities", stepId:"4", stepComponent:Commodities},
  {stepName: "CFD's Cryptos", stepId:"5", stepComponent:Cryptos},
  {stepName: "CFD's Futures", stepId:"6", stepComponent:Futures},
  {stepName: "CFD's Shares", stepId:"7", stepComponent:Shares},
]

class ProfileWizard extends React.Component {
      state={
        allSymbols: []
      }
      componentWillMount(){
        this.props.currencyFilter({size: 100000})
        this.props.currenciesFetch()
        this.props.symbolGroupFilter({size: 100000})
        this.props.symbolGroupsFetch()
        this.props.fetchAllSymbols().then((res) => {
          this.setState({...this.state, allSymbols:res.content})
        })
        if(this.props.match.params.id){
          this.props.fetchProfile(this.props.match.params.id)
          this.props.fetchSpecialCases(this.props.match.params.id)
        }
      }
      componentWillUnmount(){
        //clear single profile from redux store when exit the wizard
        this.props.fetchedSingleProfile({})
      }
      render() {
        const {currencies, symbolGroups, profileSpecialCases, selectedProfile} = this.props
        const {allSymbols} = this.state
        let additionalWizardData = {
          currencies,
          symbolGroups,
          specialCases: profileSpecialCases,
          allSymbols,
          profile: selectedProfile
        }
        return (
        <GridContainer justify="center">
          <GridItem xs={12} sm={10}>
            <CustomWizard
							panelTitle="Create/Edit Rebate"
              title="Create/Edit Rebate Profile"
              subtitle=""
              color="warning"
              match={this.props.match}
              additionalWizardData={additionalWizardData}
              history={this.props.history}
              changeTabFromNavigationAction={false}
              steps={steps} />
          </GridItem>
        </GridContainer>
        );
      }
}
const mapStateToProps=(state,props)=>({
  isFetching:state.ibs.isFetching,
  ibs:state.ibs,
  companies: state.companies.list,
  user: state.auth,
  currencies: state.currencies.list,
  platforms: state.platforms.list,
  symbolGroups: state.symbolGroups.list,
  selectedProfile: state.profiles.singleProfileFetched,
  profileSpecialCases: state.profileSpecialCases.list,
})
const mapDispatchToProps=(dispatch)=>({
  fetch:(id)=>dispatch(ibFetch(id)),
  fetchAll:()=>dispatch(ibsFetch()),
  save:(data)=>dispatch(ibSave(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  success:(text,sec)=>dispatch(success(text,sec)),
  companiesFetch: () => dispatch(companiesFetch()),
  platformsFetch: () => dispatch(plaformsFetch()),
  companyFilter: (filter) => dispatch(companyFilter(filter)),
  plaformFilter: (filter) => dispatch(plaformFilter(filter)),
  currenciesFetch: () => dispatch(currenciesFetch()),
  currencyFilter: (filter) => dispatch(currencyFilter(filter)),
  fetchAllSymbols: () => dispatch(fetchAllSymbols()),
  symbolGroupsFetch: () => dispatch(symbolGroupsFetch()),
  symbolGroupFilter: (filter) => dispatch(symbolGroupFilter(filter)),
  fetchProfile:(id)=>dispatch(profileFetch(id)),
  fetchSpecialCases:(profileId)=>dispatch(profileSpecialCasesFetch(profileId)),
  fetchedSingleProfile: (data) => dispatch(fetchedSingleProfile(data))
})
export default withStyles({...styles})(connect(mapStateToProps,mapDispatchToProps)(ProfileWizard));



// WEBPACK FOOTER //
// ./src/views/Profiles/Wizard/ProfileWizard.jsx